module.exports = __webpack_public_path__ + "edee0049e0390fb1b2c2e7f88a220e97.glb";